import {connect} from 'react-redux';
import ProgressBarPopUp from './ProgressBarPopUp';
import {hideProgressBarPopUp} from '../../actions/progressBarPopUp/hideProgressBarPopUp';

const mapStateToProps = ({
                           progressBarPopUp: {showProgressBarPopUp, message},
                         }) => ({
  showProgressBarPopUp,
  message,
});

export default connect(
  mapStateToProps,
  {hideProgressBarPopUp}
)(ProgressBarPopUp);
